export default __webpack_public_path__ + "static/media/Path 130.05ff2950.svg";